import type { ComponentType } from "react";
import { HomePageContentFallback } from "~/pages/HomePage/HomePageContentFallback";
import type { AppRouteHandle } from "~/types/routeHandle";
import { PageContentFallback } from "./PageContentFallback";

/** Pathname → content fallback. Used by RouterFallback (pre-match) and route `handle`. */
const contentFallbackByPath: Record<string, ComponentType> = {};

export function getContentFallbackForPathname(pathname: string): ComponentType {
  return contentFallbackByPath[pathname] ?? PageContentFallback;
}

function registerContentFallback(
  path: string,
  component: ComponentType
): AppRouteHandle {
  contentFallbackByPath[path] = component;
  return { contentFallback: component };
}

export const homeRouteHandle = registerContentFallback(
  "/",
  HomePageContentFallback
);
